<template lang="pug">
.d-flex.align-center
  .flex-grow-1.d-flex.align-center
    filter-panel-payment-method.mr-2(:filter.sync="panelPaymentMethodFilter" filterKey="payment_ref_ids" title="Panel")
    filter-date-range.mr-2(ref="date" :dates.sync="datesFilter" initializeDate)
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterDateRange from '@/components/clinic/reports/filters/FilterDateRange.vue'
import FilterPanelPaymentMethod from '@/components/clinic/reports/filters/FilterPanelPaymentMethod.vue'

export default {
  components: { FilterDateRange, FilterPanelPaymentMethod },
  props: ['filters'],
  data: () => ({
    datesFilter: [],
    panelPaymentMethodFilter: {}
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.datesFilter.length > 0) {
        filters.push({ key: 'date__gte', value: this.datesFilter[0] })
        filters.push({ key: 'date__lte', value: this.datesFilter[1] })
      }
      if (this.panelPaymentMethodFilter.key) {
        filters.push(this.panelPaymentMethodFilter)
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.panelPaymentMethodFilter = {}
      this.datesFilter = []
      this.$refs.date.clear()
    }
  }
}
</script>
